import { useTranslation as useTranslationOriginal, UseTranslationResponse } from 'react-i18next';

type TypedTranslationFunction = (key: string, defaultValue?: string, options?: any) => string;

interface TypedUseTranslationResponse extends Omit<UseTranslationResponse<'translation', undefined>, 't'> {
    t: TypedTranslationFunction;
}

export function useTranslation(): TypedUseTranslationResponse {
    const { t: originalT, ...rest } = useTranslationOriginal();

    const t: TypedTranslationFunction = (key, defaultValue?, options?) => {
        return originalT(key, defaultValue, options) as string;
    };

    return { t, ...rest };
}
